import { createHostModule } from '@wix/sdk-runtime/host-modules';
export const consentPolicyRuntime = createHostModule({
    getCurrentConsentPolicy: ({ channel }) => function getCurrentConsentPolicy(...args) {
        return channel.invoke({
            namespace: 'window',
            method: 'consentPolicy.getCurrentConsentPolicy',
            args,
        });
    },
    onConsentPolicyChanged: ({ channel }) => function onConsentPolicyChanged(...args) {
        return channel.invoke({
            namespace: 'window',
            method: 'consentPolicy.onConsentPolicyChanged',
            args,
        });
    },
    resetConsentPolicy: ({ channel }) => function resetConsentPolicy(...args) {
        return channel.invoke({
            namespace: 'window',
            method: 'consentPolicy.resetConsentPolicy',
            args,
        });
    },
    setConsentPolicy: ({ channel }) => function setConsentPolicy(...args) {
        return channel.invoke({
            namespace: 'window',
            method: 'consentPolicy.setConsentPolicy',
            args,
        });
    },
});
//# sourceMappingURL=consentPolicy.runtime.js.map